import { mountStoreDevtool } from 'simple-zustand-devtools'
import { UsuarioAlocacoesData } from 'types/usuario'
import { create } from 'zustand'
import { combine, persist, createJSONStorage } from 'zustand/middleware'

export interface MenuGestao {
  menu_gestao: 'canceladas' | 'nao-alocadas' | 'alocadas'
}
interface GlobalInfo extends MenuGestao {
  guid: string
  cantBack: boolean
  usuario_alocacoes: UsuarioAlocacoesData[]
}

const DEFAULT_GLOBAL_INFO: GlobalInfo = {
  menu_gestao: 'nao-alocadas',
  guid: 'DEFAULT_GUID',
  cantBack: false,
  usuario_alocacoes: {} as UsuarioAlocacoesData[]
}

const useGlobalStore = create(
  persist(
    combine(DEFAULT_GLOBAL_INFO, (set) => ({
      setCantBack: (cantBack: boolean) => set({ cantBack }),
      setMenuGestao: (menu_gestao: MenuGestao['menu_gestao']) => set({ menu_gestao }),
      setGuid: (guid: string) => set({ guid }),
      setUsuarioAlocacoes: (usuario_alocacoes: UsuarioAlocacoesData[]) =>
        set({ usuario_alocacoes }),
      resetGuid: () => set({ guid: 'DEFAULT_GUID' })
    })),
    {
      name: 'global-data-storage',
      storage: createJSONStorage(() => localStorage)
    }
  )
)

if (process.env.NODE_ENV === 'development') {
  mountStoreDevtool('Global Store', useGlobalStore)
}

export default useGlobalStore
